<template>
  <v-sheet style="border-radius:30px 30px 0px 0px" class="pa-14" height="460px">
    <v-window v-model="block">
      <v-window-item :value="1">
        <h2 class="mb-3">New Content Block</h2>
      
        <v-card
          :color="userData.btncolor"
          @click="block = 3"
          style="float:left"
          class="mr-6 mb-3 text-center pa-6"
          height="100px"
          width="100px"
        >
          <v-icon :color="userData.bg">
            mdi-play-circle-outline
          </v-icon>
          <p :style="{ color: userData.bg }">Video</p>
        </v-card>

        <v-card
          :color="userData.btncolor"
          @click="block = 4"
          style="float:left"
          class="mr-6 mb-3 text-center pa-6"
          height="100px"
          width="100px"
        >
          <v-icon :color="userData.bg">
            mdi-text
          </v-icon>
          <p :style="{ color: userData.bg }">Article</p>
        </v-card>

        <v-card
          :color="userData.btncolor"
          @click="block = 5"
          style="float:left"
          class="mr-6 text-center mb-3 pa-6"
          height="100px"
          width="100px"
        >
          <v-icon :color="userData.bg">
            mdi-link-variant
          </v-icon>
          <p :style="{ color: userData.bg }">Button</p>
        </v-card>

        <v-card
          :color="userData.btncolor"
          style="float:left"
          class="text-center mr-6 mb-3 pa-6"
          height="100px"
          width="100px"
          @click="audio = true"
        >
          <v-icon :color="userData.bg">
            mdi-volume-high
          </v-icon>
          <p :style="{ color: userData.bg }">Audio</p>
        </v-card>

        <v-card
          :color="userData.btncolor"
          @click="tiktok = true"
          style="float:left"
          class="text-center mr-6 mb-3 pa-6"
          height="100px"
          width="100px"
        >
          <v-icon :color="userData.bg">
            mdi-music-note
          </v-icon>
          <p :style="{ color: userData.bg }">Tiktok</p>
        </v-card>

        <v-card
          color="grey"
          @click="block = 2"
          style="float:left"
          class="mb-3 text-center pa-6"
          height="100px"
          width="100px"
          :disabled="imageDisabled"
        >
          <v-icon :color="userData.bg">
            mdi-image
          </v-icon>
          <p :style="{ color: userData.bg }">Image</p>
        </v-card>

      </v-window-item>
      <v-window-item :value="2" style="padding-top:20px">
        <v-btn text width="10px" @click="block = 1"
          ><v-icon small class="mr-2">mdi-arrow-left</v-icon>Back</v-btn
        >
        <div style="margin-top:20px">
          <v-text-field
            label="Insert image link"
            style="border-radius:12px;height:72px"
            single-line
            outlined
            :color="userData.btncolor"
            v-model="image"
          />
          <v-btn
            block
            :loading="btnloading"
            :color="userData.btncolor"
            style="border-radius:12px"
            :style="{ color: userData.bg }"
            @click="uploadImage()"
            x-large
          >
            Upload Image</v-btn
          >
          <v-img
            style="margin-top:15px"
            :src="image"
            height="50%"
            width="50%"
          />
        </div>
      </v-window-item>

      <v-window-item :value="3"> 
        <v-btn text width="10px" @click="block = 1"
          ><v-icon small class="mr-2">mdi-arrow-left</v-icon>Back</v-btn
        >
        <div style="margin-top:20px">
          <v-text-field
            label="Insert YouTube link"
            style="border-radius:12px;height:72px"
            single-line
            outlined
            :color="userData.btncolor"
            v-model="video"
          />
          <v-btn
            block
            :loading="btnloading"
            :color="userData.btncolor"
            style="border-radius:12px"
            :style="{ color: userData.bg }"
            @click="uploadVideo()"
            x-large
          >
           Upload Video</v-btn
          >
         <iframe  v-if="video !=''"
                  width="100%"
                  :src="computedVideo"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  style="margin-top:20px"
                  
                >
                </iframe>
        </div>

      </v-window-item>

      <v-window-item :value="4">
        <v-btn text width="10px" @click="block = 1"
          ><v-icon small class="mr-2">mdi-arrow-left</v-icon>Back</v-btn
        >
        <div style="margin-top:20px">
          <v-text-field
            label="Insert article link"
            style="border-radius:12px;height:72px"
            single-line
            outlined
            :color="userData.btncolor"
            v-model="url"
          />
          <v-btn
            block
            :loading="btnloading"
            :color="userData.btncolor"
            style="border-radius:12px"
            :style="{ color: userData.bg }"
            @click="previewArticle()"
            x-large
          >
            Preview Article</v-btn
          >
          <div style="margin:20px 5px 20px 5px">
            <v-card v-if="article !=''" style="border-radius:10px" elevation="6" class="pa-1 mt-3" height="135px" :href="article.link">
            <v-row no-gutters>
            <v-col xs=1 md=1 sm=1 lg=1>
            <v-img style="border-radius:10px" height="100px" width="70px" :src="article.banner">
            
            </v-img>
            </v-col>
            <v-col style="margin-left:-20px;margin-right:40px" xs=11 md=6 sm=6 lg=6 >
           <h2 style="font-size:15px"> {{article.title}}</h2>
            </v-col>
            </v-row>
            </v-card>
            </div>
             <v-btn
            v-if="article !=''"
            block
            :loading="uploading"
            :color="userData.btncolor"
            style="border-radius:12px"
            :style="{ color: userData.bg }"
            @click="addArticle()"
            x-large
          >
           Upload Article</v-btn
          >
        </div>
      </v-window-item>

      <v-window-item :value="5"> 
         <v-btn text width="10px" @click="block = 1"
          ><v-icon small class="mr-2">mdi-arrow-left</v-icon>Back</v-btn
        >
        <div style="margin-top:20px">
          <v-text-field
            label="Button title"
            style="border-radius:12px;height:72px"
            outlined
            :color="userData.btncolor"
            v-model="buttonName"
          />

          <v-text-field
            label="Insert button link"
            style="border-radius:12px;height:72px"
            outlined
            :color="userData.btncolor"
            v-model="button"
          />
          <v-btn
            block
            :loading="btnloading"
            :color="userData.btncolor"
            style="border-radius:12px"
            :style="{ color: userData.bg }"
            @click="addButton()"
            x-large
          >
           Add Button</v-btn
          >
        </div>
      </v-window-item>
    </v-window>
    <v-dialog v-model="audio" width="500px">
      <v-card width="500px" :color="userData.btncolor" :style="{color:userData.bg}" class="pa-5 text-center" >
        <h2> Coming Soon!</h2>
        <p>Audio Content Blocks are coming soon, {{userData.name}}! <i>For Podcasters</i></p>
        <v-btn @click="audio =! audio">Ok</v-btn>
      </v-card>
      </v-dialog>

       <v-dialog v-model="tiktok" width="500px">
      <v-card width="500px" :color="userData.btncolor" :style="{color:userData.bg}" class="pa-5 text-center" >
        <h2> Coming Soon!</h2>
        <p>Tiktok Content Blocks are coming soon, {{userData.name}}! <i>For Tiktokers</i></p>
        <v-btn @click="tiktok =! tiktok">Ok</v-btn>
      </v-card>

      </v-dialog>
  </v-sheet>
</template>

<script>
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import db from "@/db";
import axios from "axios";

export default {
  data: () => ({
    block: 1,
    image: "",
    button:"",
    btnloading: false,
    url: "",
    article:'',
    uploading:false,
    video:"",
    audio:false,
    tiktok:false,
    buttonName:"",
    imageDisabled:"true"
  }),
  props: {
    userData: {
      type: Object
    }
  },
  computed:{
    computedVideo(){
      return "https://www.youtube.com/embed/"+ this.video.split("=")[1]
    }
  },
  methods: {
    async uploadImage() {
      this.btnloading = true;
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        images: arrayUnion(this.image)
      });
      this.btnloading = false;
      this.$swal({
        title: "Image uploaded successfully",
        text: "Good job!. You've successfully added an image to your Tippings page",
        icon: "success",
        confirmButtonText: "Yay!"
      });
      setTimeout(()=>{
       location.reload()
      },1500)
    },
    previewArticle() {
      this.btnloading = true;
      axios({
        method: "post",
        url: "https://tips-api.herokuapp.com/link",
        data: {
          url: this.url
        }
      }).then(response => {
        console.log(response);
        this.article = response.data.metadata
        console.log(this.article)
        this.btnloading = false
      });
    },

    async addArticle() {
      this.btnloading = true;
      
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        articles: arrayUnion(this.article)
      })
      this.btnloading = false;
      this.$swal({
        title: "Article added successfully",
        text: "Your article has been added to your Tippings page",
        icon: "success",
        confirmButtonText: "Yay!"
      });
      setTimeout(()=>{
       location.reload()
      },1500)
    },

    async addButton() {
      this.btnloading = true;
      let payLoad = {
        name:this.buttonName,
        button:this.button
      }
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        buttons: arrayUnion(payLoad)
      });
      this.btnloading = false;
      this.$swal({
        title: "Button added successfully",
        text: "Your button has been added to your Tippings page",
        icon: "success",
        confirmButtonText: "Yay!"
      });
      setTimeout(()=>{
       location.reload()
      },1500)
    },

    async uploadVideo() {
      this.btnloading = true;
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
         videos: arrayUnion(this.computedVideo)
      });
      this.btnloading = false;
      this.$swal({
        title: "Video added successfully",
        text: "Your video has been added to your Tippings page",
        icon: "success",
        confirmButtonText: "Yay!"
      });
      setTimeout(()=>{
       location.reload()
      },1500)
    },
  }
};
</script>
